import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const initialValues = {
};

const validationSchema = Yup.object({
});

const activeCase = [
    {
        id: 0,
        title: "غیر فعال"
    }, {
        id: 1,
        title: "فعال"
    }
];


const Update = () => {

    const { readDataByFilter: readDataById } = useEntityCrud('Group/GetGroup');
    const { updateDate: updateDateGroup } = useEntityCrud('Group/UpdateGroup');
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const { isEditMode, setIsEditMode } = (true)
    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups');

    const [dataAA, setDataAA] = useState([]);


    const [businessList, setBusinessList] = useState([]);
    const [activeList, setActiveList] = useState([]);
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        setActiveList(activeCase.map(item => ({ value: item.id, label: item.title })))

        readDataBusiness().then(res => {
            setBusinessList(res.data.result.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })))
        });
    }, [])

    /*     const { state, goBack } = useNavigate();   
    
        const params = state.params || {}; */

    const onSubmit = (values) => {
        const postedData = {
            id: id,
            title: values.title,
            isActive: values.activeId.value === 0 ? false : true,
            businessId: 1,
        };
        updateDateGroup(postedData).then(res => {
            if (res.status === 200) {
                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    navigate("/group");
                    toast.success('گروه با موفقیت در سیستم ثبت شد.');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        })
    }

    useEffect(() => {
        const postedData = {
            "groupId": parseInt(id)
        };
        readDataById(postedData).then(res => {
            const data = res.data.result;
            formik.setValues({
                ...data,
                title: data.title,
                activeId: { value: data.isActive === true ? 1 : 0, label: data.isActive === true ? "فعال" : "غیر فعال" },
                businessId: { value: data.businessId, label: businessList?.find(item => item.value === data.businessId)?.label },

            });
        });
    }, [businessList]);

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {

       navigate('/group', { replace: true }); 



    }


    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">ویرایش گروه</div>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>
            <div className="card-body">
                <Form formik={formik} isEditMode={true} activeList={activeList} businessList={businessList} />
            </div>
        </div>
    );

}

export default Update;